"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../../../../../theme/styled-components"));
var useScript_1 = tslib_1.__importDefault(require("../../../../../view/hooks/useScript"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var scriptAttributes = {
    id: 'instagram-ejs',
    src: 'https://www.instagram.com/embed.js',
    async: true
};
var InstagramWrapper = function (_a) {
    var children = _a.children, config = _a.config, className = _a.className;
    React.useEffect(function () {
        var _a, _b;
        try {
            (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.instgrm) === null || _b === void 0 ? void 0 : _b.Embeds.process();
        }
        catch (e) {
            console.error(e); // tslint:disable-line:no-console
        }
    }, [config]);
    useScript_1["default"](scriptAttributes);
    return (React.createElement(Wrapper, { key: JSON.stringify(config), className: className }, children));
};
exports["default"] = InstagramWrapper;
var templateObject_1;
